import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div data-testid="loading-screen" className="min-h-screen flex items-center justify-center">
        <div className="font-display text-4xl gold-text tracking-tight">y ℶα</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role && user.role !== "admin") {
    // route based on actual role
    const target = user.role === "merchant" ? "/merchant" : "/customer";
    return <Navigate to={target} replace />;
  }
  return children;
}
